export default "__VITE_ASSET__Dewtv7Ns__"